<svelte:options runes={true} />

<script lang="ts">
  import Slider from "~/components/ui/Slider/Slider.svelte";
  import { formatMoney, dineroFromFloat } from "~/lib/money";

  interface Props {
    min: number;
    max: number;
    value?: [number, number];
    step?: number;
    onChange?: (value: [number, number]) => void;
    class?: string;
  }

  let {
    min,
    max,
    value = $bindable([min, max] as [number, number]),
    step = 10,
    onChange,
    class: className = "",
  }: Props = $props();

  function handleChange(v: number | number[]) {
    const pair = v as [number, number];
    value = pair;
    onChange?.(pair);
  }
</script>

<div class="da-price-range-slider {className}">
  <Slider
    type="multiple"
    {value}
    {min}
    {max}
    {step}
    showThumbLabels={true}
    labelPosition="bottom"
    labelFormatter={(v) => formatMoney(dineroFromFloat(v))}
    thumbLabel={(index) => (index === 0 ? "Minimum price" : "Maximum price")}
    onChange={handleChange}
    class="da-price-range-slider__track"
  />
</div>

<style>
  @layer aurora {
    .da-price-range-slider {
      --da-slider-thumb-size: 32px;
      --da-slider-label-size: var(--da-font-size-sm);
    }
  }
</style>
